module.exports = "<div class=\"qr-switch-container\" [title]=\"title\" (click)=\"toggle()\">\n  <div class=\"qr-switch-track\" [class.active]=\"value\">\n    <div class=\"qr-switch-thumb\"></div>\n  </div>\n  <span class=\"qr-switch-label\" *ngIf=\"label\">{{ label }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/ui/qr-switch/qr-switch.component.html
// module id = ../../../../../src/app/components/ui/qr-switch/qr-switch.component.html
// module chunks = 3